import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { RouterProvider } from 'react-router-dom'
import { TooltipProvider } from '@/components/ui/tooltip'
import { UserProvider } from './UserContext'
import { router } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {/* Site-wide tooltip provider with a 200ms delay - much snappier
          than the native title=""'s ~700ms browser default. All
          consumers via <Tooltip>/<TooltipTrigger>/<TooltipContent>
          inherit this. */}
      <TooltipProvider delayDuration={200} skipDelayDuration={100}>
        <UserProvider>
          <RouterProvider router={router} />
        </UserProvider>
      </TooltipProvider>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
